module.exports = __webpack_public_path__ + "static/img/1602_phase_function_Paper_PointsHejduk_Prediction.4a836f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1602_phase_function_Paper_PointsHejduk_Prediction.png
// module id = CYnE
// module chunks = 0